import { render, staticRenderFns } from "./listing-box-amenities.vue?vue&type=template&id=23c51218&scoped=true&"
import script from "./listing-box-amenities.vue?vue&type=script&lang=js&"
export * from "./listing-box-amenities.vue?vue&type=script&lang=js&"
import style0 from "./listing-box-amenities.vue?vue&type=style&index=0&id=23c51218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c51218",
  null
  
)

export default component.exports